'use client';

import { Button, cn } from '@heroui/react';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import AnimatedGridPattern from '@/components/ui/backgrounds/animated-grid-pattern';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';

export default function NotFound() {
	const pathName = usePathname();
	const { back } = useRouter();
	return (
		<main className="flex h-dvh w-full flex-col items-center justify-center gap-2">
			<AnimatedGridPattern
				numSquares={30}
				maxOpacity={0.1}
				duration={3}
				className={cn('mask-[radial-gradient(500px_circle_at_center,white,transparent)]', 'inset-0 -z-10')}
			/>
			<div className="flex flex-col items-center justify-center gap-8 p-4">
				<h1 className="text-center text-7xl select-none font-bold">Página não encontrada</h1>
				<div className="flex items-center gap-2">
					<Button onPress={back} className="font-medium" size="lg" variant="shadow" color="default">
						Voltar onde eu estava
					</Button>
					<Button
						as={Link}
						href={
							pathName.includes('/admin') || pathName.includes('/draws')
								? buildAppRoute(APP_ROUTES.PRIVATE.ADMIN.HOME)
								: buildAppRoute(APP_ROUTES.PRIVATE.HOME)
						}
						className="font-medium"
						size="lg"
						variant="shadow"
						color="success"
					>
						Início
					</Button>
				</div>
			</div>
		</main>
	);
}
